var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"homePage-container"},[(_vm.isGotMeau)?[_c('left-model',{attrs:{"meau":_vm.meauList}}),_c('middle-model',{attrs:{"meau":_vm.meauList}}),_c('right-model',{attrs:{"meau":_vm.resourceMenuList}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }